import Yup from "yup";
import * as Constants from "common/constants";

export const name = (t) => Yup.object().shape({
  name: Yup.string().required(t("offer_form_errors.name_required")),
});

export const type = (t) => Yup.object().shape({
  offer_template: Yup.object().shape({
    id: Yup.string().required(t("offer_form_errors.type_offer_temp_required")),
  }),
});

export const info = (t) => Yup.object().shape({
  short_description: Yup.string()
    .max(
      Constants.SHORT_DESCRIPTION_MAX_LENGTH,
      t("offer_form_errors.info_sm_desc_max", { maxValue: Constants.SHORT_DESCRIPTION_MAX_LENGTH })
    )
    .required(t("offer_form_errors.info_desc_required")),
  custom_values: Yup.object().required("custom value is required"),
  long_description: Yup.string()
    .required(t("offer_form_errors.info_desc_required"))
    .max(
      Constants.LONG_DESCRIPTION_MAX_LENGTH,
      t("offer_form_errors.info_lg_desc_max", { maxValue: Constants.LONG_DESCRIPTION_MAX_LENGTH })
    ),
  quantity: Yup.number(),
  legal: Yup.string(),
  hero_url: Yup.string().required(t("offer_form_errors.info_hero_url_required")),
  start_at: Yup.date().required(t("offer_form_errors.info_start_date")),
  end_at: Yup.date()
    .required(t("offer_form_errors.info_end_date"))
    .test(
      "end_after_start",
      t("offer_form_errors.info_date_order"),
      function (value) {
        const { start_at } = this.parent || {};
        if (!value || !start_at) return true;
        return new Date(value) >= new Date(start_at);
      },
    ),
  target: Yup.string().required(t("offer_form_errors.info_target_required")),
});
